import styled from "styled-components";
import imgNoiseBkg from "@/assets/images/signup/bkg-noise-dark.png";

export const AuthPage = styled.div`
  font-family: "Inter Variable", sans-serif;
  font-weight: 300;
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  @media (width <= 767px) {
    flex-direction: column;
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }
`;

export const AuthLeftPanel = styled.div`
  flex: 0 0 45%;
  box-sizing: border-box;
  position: relative;
  background: #0d1117;
  background-image: url(${imgNoiseBkg});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left top;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: clamp(28px, 4vh, 52px) clamp(28px, 4vw, 56px);
  overflow: hidden;

  @media (width <= 767px) {
    display: none;
  }
`;

export const AuthRightPanel = styled.div`
  flex: 0 0 55%;
  box-sizing: border-box;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 48px 32px;

  @media (width <= 767px) {
    flex: 1;
    width: 100%;
    min-height: 100vh;
    align-items: center;
    justify-content: center;
    padding: 48px 24px;
  }
`;
